import React from "react";
import { Badge } from "@/components/ui/badge";
import type { OrderStatus } from "./orderTypes";

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  DRAFT: "Draft",
  CONFIRMED: "Confirmed",
  IN_PROGRESS: "In progress",
  DELIVERED: "Delivered",
  CANCELLED: "Cancelled",
};

const VARIANTS: Record<OrderStatus, "default" | "secondary" | "destructive" | "outline" | "success" | "warning" | "blue"> = {
  DRAFT: "secondary",
  CONFIRMED: "blue",
  IN_PROGRESS: "warning",
  DELIVERED: "success",
  CANCELLED: "destructive",
};

export function OrderStatusBadge({ status }: { status: OrderStatus }) {
  return <Badge variant={VARIANTS[status] || "outline"}>{ORDER_STATUS_LABELS[status] || status}</Badge>;
}
